/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetBumpsDetailResponse } from '../models/get-bumps-detail-response';
import { CreateBumpsDetailRequest } from '../models/create-bumps-detail-request';
import { UpdateBumpsDetailRequest } from '../models/update-bumps-detail-request';
@Injectable({
  providedIn: 'root',
})
class BumpsDetailService extends __BaseService {
  static readonly BumpsDetailGetAllPath = '/BumpsDetail/GetAll';
  static readonly BumpsDetailGetByIdPath = '/BumpsDetail/GetById';
  static readonly BumpsDetailCreatePath = '/BumpsDetail/Create';
  static readonly BumpsDetailCreateRangePath = '/BumpsDetail/CreateRange';
  static readonly BumpsDetailUpdatePath = '/BumpsDetail/Update';
  static readonly BumpsDetailDeletePath = '/BumpsDetail/Delete';
  static readonly BumpsDetailDeleteRangePath = '/BumpsDetail/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  BumpsDetailGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetBumpsDetailResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/BumpsDetail/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetBumpsDetailResponse>>;
      })
    );
  }  BumpsDetailGetAll(): __Observable<Array<GetBumpsDetailResponse>> {
    return this.BumpsDetailGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetBumpsDetailResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  BumpsDetailGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetBumpsDetailResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/BumpsDetail/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetBumpsDetailResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  BumpsDetailGetById(Id?: string): __Observable<GetBumpsDetailResponse> {
    return this.BumpsDetailGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetBumpsDetailResponse)
    );
  }

  /**
   * @param request undefined
   */
  BumpsDetailCreateResponse(request: CreateBumpsDetailRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/BumpsDetail/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  BumpsDetailCreate(request: CreateBumpsDetailRequest): __Observable<string> {
    return this.BumpsDetailCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  BumpsDetailCreateRangeResponse(request: Array<CreateBumpsDetailRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/BumpsDetail/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  BumpsDetailCreateRange(request: Array<CreateBumpsDetailRequest>): __Observable<Blob> {
    return this.BumpsDetailCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  BumpsDetailUpdateResponse(request: UpdateBumpsDetailRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/BumpsDetail/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  BumpsDetailUpdate(request: UpdateBumpsDetailRequest): __Observable<Blob> {
    return this.BumpsDetailUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  BumpsDetailDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/BumpsDetail/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  BumpsDetailDelete(id?: string): __Observable<Blob> {
    return this.BumpsDetailDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  BumpsDetailDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/BumpsDetail/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  BumpsDetailDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.BumpsDetailDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module BumpsDetailService {
}

export { BumpsDetailService }
